import React from 'react';

import ARS from '@/assets/flags/ar.svg?react';
import BRL from '@/assets/flags/br.svg?react';
import CNY from '@/assets/flags/cn.svg?react';
import COP from '@/assets/flags/co.svg?react';
import EUR from '@/assets/flags/eur.svg?react';
import HKD from '@/assets/flags/hk.svg?react';
import MXN from '@/assets/flags/mx.svg?react';
import SGD from '@/assets/flags/sg.svg?react';
import USD from '@/assets/flags/us.svg?react';
import BRL1 from '@/assets/icons/brl1.svg?react';
import DigitalDollars from '@/assets/icons/digital-dollars.svg?react';
import MXNB from '@/assets/icons/mxnb.svg?react';
import USDT from '@/assets/icons/tether.svg?react';
import EmptyFlag from '@/assets/icons/unset.svg?react';
import EMPTY from '@/assets/icons/unset.svg?react';
import USDC from '@/assets/icons/usdc.svg?react';
import { CurrencyCodeType } from '@/types/currency';
import { isCurrencyCodeType } from '@/types/currency.ext';
import { Locale } from '@/types/locale';
import { getCurrencyName } from '@/utility/formatAmount';

export interface SpinnerProps {
  readonly width: undefined;
  readonly height: number;
}

export interface Currency {
  readonly icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  readonly name: string;
  readonly code: CurrencyCodeType;
}

export class Currency {
  public static fromCode(
    locale: Locale,
    currencyCode: CurrencyCodeType | string,
    displayUsdcAsUsd: boolean = false,
  ): Currency {
    if (!isCurrencyCodeType(currencyCode)) {
      return {
        code: CurrencyCodeType.UNSET,
        name: '',
        icon: EMPTY,
      };
    }

    if (currencyCode === '') {
      return {
        code: CurrencyCodeType.UNSET,
        name: '',
        icon: EMPTY,
      };
    }

    if (!icons[currencyCode]) {
      return {
        code: currencyCode,
        name: currencyCode,
        icon: EMPTY,
      };
    }

    if (currencyCode === CurrencyCodeType.USDC) {
      return {
        code: currencyCode,
        name: getCurrencyName(locale, currencyCode, displayUsdcAsUsd),
        icon: displayUsdcAsUsd ? DigitalDollars : (icons[currencyCode] ?? EmptyFlag),
      };
    } else {
      return {
        code: currencyCode,
        name: currencyCode,
        icon: icons[currencyCode] ?? EmptyFlag,
      };
    }
  }
}

export const icons: Record<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
  ARS: ARS,
  BRL: BRL,
  BRL1: BRL1,
  CNY: CNY,
  COP: COP,
  EUR: EUR,
  HKD: HKD,
  MXN: MXN,
  MXNB: MXNB,
  SGD: SGD,
  USD: USD,
  USDC: USDC,
  USDT: USDT,
};
